import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as FPT from '../../utility/fpt'

const STYLES = {
	error: {
		color: '#D20000',
		fontSize: '13px',
		fontFamily: 'pp-sans-small-regular'
	},
	criticalIcon: {
		color: '#D20000',
		position: 'relative',
		top: '-2px',
		height: '13.18px',
		width: '14.83px'
	},
}

/**
 * Component for displaying amount validation error message
 */
class AmountValidationError extends Component {
	componentDidMount() {
		const { errorSourceField, donationAmount } = this.props;
		FPT.trackError({
			message: `Donation Amount: ${donationAmount}`,
			fieldId: errorSourceField,
			code: 'MINIMUM_DONATION_ERROR'
		});

	}
	render() {
		const { errorString } = this.props;

		if (!errorString) {
			return null;
		}

		return (
			<span>
				<span
					className="icon icon-critical-small"
					style={{ ...STYLES.criticalIcon }}
					aria-hidden="true"
				/>
				<span style={STYLES.error} data-testid="amount-validation-error">
					{errorString}
				</span>
			</span>
		);
	}
}

AmountValidationError.propTypes = {
	errorString: PropTypes.string,
	errorSourceField: PropTypes.string,
	donationAmount: PropTypes.string
};

export default AmountValidationError;



// WEBPACK FOOTER //
// ./components/amount/amountValidationError.js